// extracted by mini-css-extract-plugin
export default {"horizontal":"yvF3w","vertical":"_5gUm9","bullet":"pwe+J"};